export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-male-female-648ee44519a12a3f44ae479a3c8e30d5.svg";